export default {
  computed: {
    activeCalculationData() {
      return this.$store.state.calculation.activeCalculationData;
    },
    reactiveCalculationData() {
      return this.$store.state.reactive.reactiveCalculationData;
    },
  },
  methods: {
    calculateDeals(customerType, deals) {
      // if (customerT, ype === 1) {
      return this.calculateResidential(deals);
      // }
      // return [];
    },
    calculateResidential(deals) {
      const cd = this.activeCalculationData;
      const rcd = this.reactiveCalculationData;
      console.log(rcd.reactiveHT);
      return deals.map((deal) => {
        let activeHTPrice = cd.activeHT * deal.active_energy_vt;
        activeHTPrice /= 100;

        let activeLTPrice = cd.activeLT * deal.active_energy_mt;
        activeLTPrice /= 100;

        let activeTotal = activeHTPrice + activeLTPrice;
        activeTotal /= 100;

        let reactiveHTPrice = rcd.reactiveHT * deal.reactive_energy_vt;
        reactiveHTPrice /= 100;

        let reactiveLTPrice = rcd.reactiveLT * deal.reactive_energy_mt;
        reactiveLTPrice /= 100;

        let lossHT = cd.activeHT * deal.loss_vt;
        lossHT /= 100;

        let lossLT = cd.activeLT * deal.loss_mt;
        lossLT /= 100;

        let networkCapacity =
          (cd.activeHT + cd.activeLT) * deal.network_capacity;
        networkCapacity /= 100;

        const fixedNetworkCapacity = 1 * deal.fixed_network_capacity;

        let operator =
          (cd.activeHT + cd.activeLT) * deal.operator;
        operator /= 100;

        let oie =
          (cd.activeHT + cd.activeLT) * deal.OIE;
        oie /= 100;

        const neto =
          activeHTPrice +
          activeLTPrice +
          reactiveHTPrice +
          reactiveLTPrice +
          lossHT +
          lossLT +
          networkCapacity +
          fixedNetworkCapacity +
          operator +
          oie;
        const vat = neto * 0.21;
        const totalMonthly = neto + vat;
        let totalAnnually = neto / (cd.activeHT + cd.activeLT);
        totalAnnually *= 100;

        const calculatedData = {
          activeHTUsage: cd.activeHT,
          activeLTUsage: cd.activeLT,
          activeHTPrice,
          activeLTPrice,
          activeTotal,
          lossHT,
          lossLT,
          networkCapacity,
          fixedNetworkCapacity,
          operator,
          oie,
          neto,
          vat,
          totalMonthly,
          totalAnnually,
        };

        return { ...deal, calculatedData };
      });
    },
  },
};
